import { CFTokens } from '../../../../../tokens';
export const BORDER_COLOR = {
    ALTERNATE: {
        alert: {
            strong: CFTokens.COLOR.TRANSPARENT,
            subtle: CFTokens.COLOR.TRANSPARENT,
        },
        default: {
            strong: CFTokens.COLOR.TRANSPARENT,
            subtle: CFTokens.COLOR.TRANSPARENT,
        },
        neutral: {
            strong: CFTokens.COLOR.TRANSPARENT,
            subtle: CFTokens.COLOR.TRANSPARENT,
        },
        success: {
            strong: CFTokens.COLOR.TRANSPARENT,
            subtle: CFTokens.COLOR.TRANSPARENT,
        },
    },
    DEFAULT: {
        alert: {
            strong: CFTokens.COLOR.TRANSPARENT,
            subtle: CFTokens.COLOR.CHROMATIC_STRAWBERRY_ALTERNATE_MID_TONE,
        },
        default: {
            strong: CFTokens.COLOR.TRANSPARENT,
            subtle: CFTokens.COLOR.CHROMATIC_PRIMARY_MID_TONE,
        },
        neutral: {
            strong: CFTokens.COLOR.TRANSPARENT,
            subtle: CFTokens.COLOR.MONO_4,
        },
        success: {
            strong: CFTokens.COLOR.TRANSPARENT,
            subtle: CFTokens.COLOR.CHROMATIC_FOREST_MID_TONE,
        },
    },
};
export const ROOT_COLOR = {
    ALTERNATE: {
        alert: {
            strong: CFTokens.COLOR.CHROMATIC_STRAWBERRY_ALTERNATE_CONTRAST,
            subtle: CFTokens.COLOR.CHROMATIC_STRAWBERRY_CONTRAST,
        },
        default: {
            strong: CFTokens.COLOR.CHROMATIC_PRIMARY_ALTERNATE_CONTRAST,
            subtle: CFTokens.COLOR.CHROMATIC_PRIMARY_ALTERNATE_SUBTLE,
        },
        neutral: {
            strong: CFTokens.COLOR.BACKGROUND_DEFAULT,
            subtle: CFTokens.COLOR.MONO_7,
        },
        success: {
            strong: CFTokens.COLOR.CHROMATIC_FOREST_ALTERNATE_CONTRAST,
            subtle: CFTokens.COLOR.CHROMATIC_FOREST_ALTERNATE_SUBTLE,
        },
    },
    DEFAULT: {
        alert: {
            strong: CFTokens.COLOR.CHROMATIC_STRAWBERRY_CONTRAST,
            subtle: CFTokens.COLOR.CHROMATIC_STRAWBERRY_SUBTLE,
        },
        default: {
            strong: CFTokens.COLOR.BACKGROUND_DEFAULT_DARK,
            subtle: CFTokens.COLOR.BACKGROUND_BRAND_ACCENT,
        },
        neutral: {
            strong: CFTokens.COLOR.MONO_7,
            subtle: CFTokens.COLOR.BACKGROUND_COOL_2,
        },
        success: {
            strong: CFTokens.COLOR.CHROMATIC_FOREST_CONTRAST,
            subtle: CFTokens.COLOR.CHROMATIC_FOREST_SUBTLE,
        },
    },
};
export const VALUE_COLOR = {
    ALTERNATE: {
        alert: {
            strong: CFTokens.COLOR.CHROMATIC_STRAWBERRY_CONTRAST,
            subtle: CFTokens.COLOR.CHROMATIC_STRAWBERRY_ALTERNATE_CONTRAST,
        },
        default: {
            strong: CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT,
            subtle: CFTokens.COLOR.TEXT_AND_ELEMENT_ACCENT,
        },
        neutral: {
            strong: CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT,
            subtle: CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE,
        },
        success: {
            strong: CFTokens.COLOR.CHROMATIC_FOREST_ALTERNATE_SUBTLE,
            subtle: CFTokens.COLOR.CHROMATIC_FOREST_ALTERNATE_CONTRAST,
        },
    },
    DEFAULT: {
        alert: {
            strong: CFTokens.COLOR.CHROMATIC_STRAWBERRY_SUBTLE,
            subtle: CFTokens.COLOR.CHROMATIC_STRAWBERRY_CONTRAST,
        },
        default: {
            strong: CFTokens.COLOR.TEXT_AND_ELEMENT_ACCENT,
            subtle: CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT,
        },
        neutral: {
            strong: CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE,
            subtle: CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT,
        },
        success: {
            strong: CFTokens.COLOR.CHROMATIC_FOREST_SUBTLE,
            subtle: CFTokens.COLOR.CHROMATIC_FOREST_CONTRAST,
        },
    },
};
